module.exports = __webpack_public_path__ + "img/review-photo-2.6a72ec4.jpg";